// The 1 product-shadow lives here. Status orb is the "product" Apple shadow rule
// reserves for. Color maps:
//   normal    → action blue
//   note      → ink (subtle, almost no signal)
//   attention → ink with shadow (rises off page)
//   urgent    → red, shadow + pulse

const STATUS_COLOR: Record<string, string> = {
  normal: "#0066cc",
  note: "#7a7a7a",
  attention: "#1d1d1f",
  urgent: "#a84a3a"
};

export function StatusOrb({
  status,
  size = 14
}: {
  status: "normal" | "note" | "attention" | "urgent";
  size?: number;
}) {
  const color = STATUS_COLOR[status] ?? "#7a7a7a";
  const useShadow = status === "attention" || status === "urgent";
  return (
    <span
      aria-label={`status-${status}`}
      className="inline-block rounded-pill"
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        boxShadow: useShadow ? "rgba(0, 0, 0, 0.22) 3px 5px 30px 0px" : undefined
      }}
    />
  );
}

export function statusLabel(status: string): string {
  switch (status) {
    case "normal":
      return "Bình thường";
    case "note":
      return "Lưu ý";
    case "attention":
      return "Bất thường";
    case "urgent":
      return "Khẩn";
    default:
      return status;
  }
}
